<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>中文官网</el-breadcrumb-item>
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>资讯管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span>
        <el-button type="primary" size="small" @click="addDialog">新增资讯</el-button>
      </span>
    </div>
    <div>
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          @sort-change="changeColumnSort"
          style="width: 100%"
        >
          <el-table-column align="center" label="排序" width="80" prop="sort" sortable="custom">
            <template slot-scope="scope">
              <el-input
                size="small"
                v-model="scope.row.sort"
                :min="0"
                :max="1000"
                @change="changeSort(scope.row)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="title" label="标题"></el-table-column>
          <el-table-column align="center" prop="type" label="类型"></el-table-column>
          <el-table-column
            align="center"
            prop="release_time"
            label="发布日期"
            column-key="release_date"
            sortable="custom"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.release_time | formatDate('YYYY-MM-DD')}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="首页可见">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.is_visible?'可见':'不可见'" placement="top">
                <el-switch
                  v-model="scope.row.is_visible"
                  @change="handleChangeStatus(scope.row, 'visible_status','is_visible')"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                ></el-switch>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="140">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="editDialog(scope.row.id)">编辑</el-button>
              <el-popconfirm
                confirmButtonText="确定"
                cancelButtonText="返回"
                icon="el-icon-info"
                iconColor="red"
                title="删除不可恢复，确定删除吗？"
                @confirm="delNews(scope.row.id)"
              >
                <el-button type="primary" size="small" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[50, 100, 200, 500]"
            :page-size="page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </template>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogAddVisible"
      :close-on-click-modal="false"
      width="900px"
      class="padding_10"
    >
      <el-form :model="newsForm" :rules="newsRules" label-width="120px" ref="newsForm">
        <el-form-item label="标题" prop="title">
          <el-input v-model="newsForm.title" auto-complete="off" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-input v-model="newsForm.type" auto-complete="off" placeholder="请输入类型"></el-input>
        </el-form-item>
        <el-form-item label="发布日期" prop="release_date">
          <el-date-picker
            v-model="newsForm.release_date"
            style="width: 100%"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="资讯中心描述" prop="desc">
          <el-input v-model="newsForm.desc" auto-complete="off" placeholder="请输入资讯中心描述"></el-input>
        </el-form-item>
        <el-form-item label="内容文案" prop="content">
          <template>
            <Editor
              style="text-align: justify!important;"
              v-model="newsForm.content"
              :isClear="isClear"
              @content="setContent"
            ></Editor>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          :loading="addLoading"
          @click="addNews('newsForm')"
        >保 存</el-button>
        <el-button size="small" @click="callOf('newsForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogEditVisible"
      :close-on-click-modal="false"
      width="900px"
      class="padding_10"
    >
      <el-form :model="newsForm" :rules="newsRules" label-width="120px" ref="editForm">
        <el-form-item label="标题" prop="title">
          <el-input v-model="newsForm.title" auto-complete="off" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-input v-model="newsForm.type" auto-complete="off" placeholder="请输入类型"></el-input>
        </el-form-item>
        <el-form-item label="发布日期" prop="release_date">
          <el-date-picker
            v-model="newsForm.release_date"
            type="date"
            value-format="timestamp"
            style="width: 100%"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="资讯中心描述" prop="desc">
          <el-input v-model="newsForm.desc" auto-complete="off" placeholder="请输入资讯中心描述"></el-input>
        </el-form-item>
        <el-form-item label="内容文案" prop="content">
          <template>
            <Editor
              style="text-align: justify!important;"
              v-model="newsForm.content"
              :isClear="isClear"
              @content="setContent"
            ></Editor>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          :loading="editLoading"
          @click="editNews('editForm')"
        >保 存</el-button>
        <el-button size="small" @click="callOf('editForm')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { newsList, changeNewsStatus, addNews, newsInfo, editNews, delNews, changeSort } from '../../api/news'
import Editor from '../../components/Editor'
export default {
  data () {
    return {
      editLoading: false,
      addLoading: false,
      page: 1,
      page_size: 50,
      total: 0,
      tableData: [],
      isClear: false,
      dialogTitle: '',
      dialogAddVisible: false,
      dialogEditVisible: false,
      newsForm: {
        id: 0,
        title: '',
        typeParameters: '',
        desc: '',
        content: '',
        release_date: ''
      },
      order_column: '',
      order_mode: '',
      newsRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请输入类型', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容文案', trigger: 'blur' }
        ],
        release_date: [
          { required: true, message: '请選擇发布日期', trigger: 'change' }
        ],
        desc: [
          { required: true, message: '请输入资讯标题', trigger: 'blur' }
        ]
      }
    }
  },
  components: { Editor },
  mounted () {
    // 页面数据初始化表格数据
    this.setTableData()
  },
  methods: {
    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 每页数据数切换
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },
    // 表格数据填充
    setTableData () {
      newsList({
        page: this.page,
        page_size: this.page_size,
        order: this.order_column,
        order_mode: this.order_mode
      }).then(res => {
        let { status, message } = res
        if (status === 2000) {
          this.tableData = res.data.data_list
          this.total = res.data.total
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 更改状态
    handleChangeStatus (row, column, rowColumn) {
      changeNewsStatus({
        id: row.id,
        column: column,
        status: row[rowColumn]
      }).then(res => {
        let { status, message } = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.setTableData()
      })
    },
    // 打开添加弹窗
    addDialog () {
      this.dialogTitle = '新增资讯'
      this.dialogAddVisible = true
      this.newsForm.content = ''
    },
    // 关闭弹窗
    callOf (formName) {
      if (formName === 'newsForm') {
        this.dialogAddVisible = false
      } else if (formName === 'editForm') {
        this.dialogEditVisible = false
      }
      if (formName) {
        this.$refs[formName].resetFields()
      }
    },
    // 富文本回调赋值
    setContent (value) {
      this.newsForm.content = value
    },
    // 更改排序
    changeSort (row) {
      changeSort({
        id: row.id,
        sort: row.sort
      }).then(res => {
        let { status, message } = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.setTableData()
      })
    },
    // 添加资讯
    addNews (formName) {
      this.addLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addNews(this.newsForm).then(res => {
            let { status, message } = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.setTableData()
              this.dialogAddVisible = false
              this.$refs[formName].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
      setTimeout(() => {
        this.addLoading = false
      }, 500)
    },
    // 打开编辑弹窗
    editDialog (id) {
      this.dialogTitle = '编辑资讯'
      this.dialogEditVisible = true
      this.newsForm.content = ''
      newsInfo({ id: id }).then(res => {
        let { status, message } = res
        if (status === 2000) {
          this.newsForm = {
            id: res.data.id,
            title: res.data.title,
            type: res.data.type,
            desc: res.data.desc,
            content: res.data.content,
            release_date: res.data.release_time
          }
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 修改资讯
    editNews (formName) {
      this.editLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let storeData = {
            id: this.newsForm.id,
            title: this.newsForm.title,
            type: this.newsForm.type,
            desc: this.newsForm.desc,
            content: this.newsForm.content,
            release_date: this.newsForm.release_date
          }
          editNews(storeData).then(res => {
            let { status, message } = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.setTableData()
              this.dialogEditVisible = false
              this.$refs[formName].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
      setTimeout(() => {
        this.editLoading = false
      }, 500)
    },
    // 删除资讯
    delNews (id) {
      delNews({
        id: id
      }).then(res => {
        let { status, message } = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
          this.setTableData()
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    changeColumnSort (field) {
      if (field.order) {
        this.order_column = field.prop
        this.order_mode = field.order === 'ascending' ? 'asc' : 'desc'
      } else {
        this.order_column = ''
        this.order_mode = ''
      }
      this.setTableData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/news/index.vue